var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "details-view", staticStyle: { overflow: "auto" } },
        [
          _c(
            "div",
            { staticStyle: { "margin-top": "5px" } },
            [
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "Cancel" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "Save" },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  )
                : _vm._e(),
              !_vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "Back" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("back")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
                  )
                : _vm._e(),
              !_vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        disabled:
                          _vm.form.status ===
                          _vm.SystemConstants.INQUIRY_STATUS_SUBMITTED.code,
                        type: "primary",
                        no: "Edit"
                      },
                      on: { click: _vm.edit }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      _vm.isEdit ||
                      _vm.form.status ===
                        _vm.SystemConstants.INQUIRY_STATUS_SUBMITTED.code,
                    type: "primary",
                    no: "submit"
                  },
                  on: { click: _vm.submitStep1 }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      _vm.isEdit ||
                      _vm.form.status !==
                        _vm.SystemConstants.INQUIRY_STATUS_SUBMITTED.code,
                    type: "primary",
                    no: "remoteBooking"
                  },
                  on: { click: _vm.remoteBooking }
                },
                [_vm._v(_vm._s(_vm.$t("Pricing.RemoteBooking")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.isEdit, type: "primary", no: "print" },
                  on: { click: _vm.toPrint }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "15px" },
                  attrs: { disabled: !_vm.isEdit, no: "trunkLineEnable" },
                  on: { change: _vm.trunkLineEnableChange },
                  model: {
                    value: _vm.form.trunkLineEnable,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "trunkLineEnable", $$v)
                    },
                    expression: "form.trunkLineEnable"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MainlinePrice")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { disabled: !_vm.isEdit, no: "prePortEnable" },
                  on: { change: _vm.prePortEnableChange },
                  model: {
                    value: _vm.form.prePortEnable,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "prePortEnable", $$v)
                    },
                    expression: "form.prePortEnable"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PrePortPrice")))]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { disabled: !_vm.isEdit, no: "lastMileEnable" },
                  on: { change: _vm.lastMileEnableChange },
                  model: {
                    value: _vm.form.lastMileEnable,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "lastMileEnable", $$v)
                    },
                    expression: "form.lastMileEnable"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LastMilePrice")))]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "main-content",
              staticStyle: { width: "fit-content" }
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: !_vm.isEdit,
                          "label-width": "140px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BasicInfo")))
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_EnquiryNumber")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.inquiryPriceNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "inquiryPriceNo", $$v)
                                },
                                expression: "form.inquiryPriceNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Enquirer") }
                          },
                          [
                            _c("cargo-user-select", {
                              attrs: {
                                "default-value": _vm.form.createdBy,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SalesDepartment")
                            }
                          },
                          [
                            _c("cargo-department-select", {
                              attrs: {
                                no: "salesDepartment",
                                disabled: "",
                                "office-id": Number(_vm.form.salesOffice),
                                "department-id": Number(
                                  _vm.form.salesDepartment
                                )
                              },
                              on: {
                                change: function(p) {
                                  _vm.form.salesDepartment = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SalesCompany")
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("cargo-office-select", {
                                  staticStyle: { width: "95%" },
                                  attrs: {
                                    no: "salesOffice",
                                    disabled: "",
                                    "tag-name": _vm.officeLabel,
                                    "office-id": Number(_vm.form.salesOffice)
                                  }
                                }),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.$t(
                                        "CargoMsg.CargoMsg_CurrentIdentityNotice"
                                      ),
                                      placement: "right-end"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning",
                                      staticStyle: {
                                        color: "orange",
                                        "margin-left": "10px"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.transportation"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                on: {
                                  change: function($event) {
                                    _vm.form.branchLine =
                                      _vm.form.transportMode ===
                                      _vm.SystemConstants.PRICE_METHOD_DIRECT
                                        .code
                                        ? 0
                                        : _vm.form.branchLine
                                  }
                                },
                                model: {
                                  value: _vm.form.transportMode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "transportMode", $$v)
                                  },
                                  expression: "form.transportMode"
                                }
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { "margin-right": "5px" },
                                    attrs: {
                                      label:
                                        _vm.SystemConstants.PRICE_METHOD_DIRECT
                                          .code
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_DirectHaul")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { "margin-right": "5px" },
                                    attrs: {
                                      label:
                                        _vm.SystemConstants.PRICE_METHOD_BRANCH
                                          .code
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_SideLine"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.form.transportMode ===
                        _vm.SystemConstants.PRICE_METHOD_BRANCH.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_SideLineType")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "branchLine",
                                    "tag-value": "code",
                                    filterable: "",
                                    clearable: false,
                                    "default-value": _vm.form.branchLine,
                                    "static-options":
                                      _vm.SystemConstants.BRANCH_LINES
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.branchLine = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PalletType"),
                              required: ""
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "palletNature",
                                "tag-value": "code",
                                filterable: "",
                                clearable: false,
                                "default-value": _vm.form.palletNature,
                                "static-options":
                                  _vm.SystemConstants.PALLET_NATURES
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.palletNature = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.CargoReadyDate"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "el-tabs",
                              {
                                on: {
                                  "tab-click": _vm.cargoReadyTimeTypeChange
                                },
                                model: {
                                  value: _vm.form.cargoReadyTimeType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "cargoReadyTimeType",
                                      $$v
                                    )
                                  },
                                  expression: "form.cargoReadyTimeType"
                                }
                              },
                              [
                                _c("el-tab-pane", {
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    label: _vm.$t("CargoMsg.Cargo_Range"),
                                    name:
                                      _vm.SystemConstants
                                        .CARGO_READY_TIME_TYPE_RANGE.code
                                  }
                                }),
                                _c("el-tab-pane", {
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    label: _vm.$t("CargoMsg.Cargo_Date"),
                                    name:
                                      _vm.SystemConstants
                                        .CARGO_READY_TIME_TYPE_DATE.code
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.form.cargoReadyTimeType ===
                            _vm.SystemConstants.CARGO_READY_TIME_TYPE_RANGE.code
                              ? _c("cargo-advance-select", {
                                  attrs: {
                                    no: "cargoReadyTimeRange",
                                    "tag-value": "code",
                                    filterable: "",
                                    clearable: false,
                                    "default-value":
                                      _vm.form.cargoReadyTimeRange,
                                    "static-options":
                                      _vm.SystemConstants
                                        .CARGO_READY_TIME_RANGES
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.cargoReadyTimeRange = p.value
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.form.cargoReadyTimeType ===
                            _vm.SystemConstants.CARGO_READY_TIME_TYPE_DATE.code
                              ? _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "cargoReadyTimeDate",
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd",
                                    format: "yyyy-MM-dd"
                                  },
                                  model: {
                                    value: _vm.form.cargoReadyTimeDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "cargoReadyTimeDate",
                                        $$v
                                      )
                                    },
                                    expression: "form.cargoReadyTimeDate"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Terms") } },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "serviceTerm",
                                filterable: "",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_IncoTerm,
                                "callback-method-type": "value",
                                "default-value": _vm.form.serviceTerm,
                                "callback-params": { key: "incoTerm" }
                              },
                              on: {
                                parentCallBack: function(p) {
                                  return (_vm.form.serviceTerm = p.value)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm.form.customerIdType ===
                        _vm.SystemConstants.CUSTOMER_ID_TYPE_OFFICIAL.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.ConsignationCompany")
                                }
                              },
                              [
                                _vm.accountObjectControlMode === 2
                                  ? _c("cargo-sales-company-select", {
                                      attrs: {
                                        filterable: "",
                                        no: "customerId",
                                        "default-value":
                                          Number(_vm.form.customerId) || "",
                                        "method-params": {
                                          customer: true,
                                          companyLob: "seaExport",
                                          active: true
                                        },
                                        cache: false,
                                        "tag-name": _vm.isZh
                                          ? "chineseName"
                                          : "englishName"
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.customerId = p.cmpIdx + ""
                                        }
                                      }
                                    })
                                  : _c("cargo-advance-select", {
                                      attrs: {
                                        filterable: "",
                                        no: "customerId",
                                        "select-type":
                                          _vm.TYPE_NAMES.basic_data_Company,
                                        "default-value":
                                          Number(_vm.form.customerId) || "",
                                        "method-params": {
                                          customer: true,
                                          companyLob: "seaExport",
                                          active: true
                                        },
                                        cache: false,
                                        "tag-name": _vm.isZh
                                          ? "chineseName"
                                          : "englishName",
                                        "static-options": _vm.customerCmpList
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.customerId = p.cmpIdx + ""
                                        }
                                      }
                                    })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.customerIdType ===
                        _vm.SystemConstants.CUSTOMER_ID_TYPE_TEMPORARY.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.Addr"),
                                  required: ""
                                }
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.form.address,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "address", $$v)
                                    },
                                    expression: "form.address"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.prePortEnable
                          ? _c(
                              "el-form",
                              {
                                staticClass: "form-item-200",
                                attrs: {
                                  disabled: !_vm.isEdit,
                                  inline: true,
                                  "label-position": "right"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c("cargo-area", {
                                      ref: "prePortArea",
                                      staticStyle: {
                                        display: "inline-block",
                                        "margin-left": "115px"
                                      },
                                      attrs: {
                                        no: "area",
                                        country: "CN",
                                        province: _vm.form.province,
                                        city: _vm.form.city,
                                        district: _vm.form.districts,
                                        town: _vm.form.townUuid,
                                        "show-town": true,
                                        "select-width": 150
                                      },
                                      on: {
                                        "update:province": function($event) {
                                          return _vm.$set(
                                            _vm.form,
                                            "province",
                                            $event
                                          )
                                        },
                                        "update:city": function($event) {
                                          return _vm.$set(
                                            _vm.form,
                                            "city",
                                            $event
                                          )
                                        },
                                        "update:district": function($event) {
                                          return _vm.$set(
                                            _vm.form,
                                            "districts",
                                            $event
                                          )
                                        },
                                        "update:town": function($event) {
                                          return _vm.$set(
                                            _vm.form,
                                            "townUuid",
                                            $event
                                          )
                                        }
                                      }
                                    }),
                                    _vm.isEdit
                                      ? _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              height: "32px",
                                              margin: "4px 0 0 10px"
                                            },
                                            attrs: {
                                              no: "aiRecognitionRegion",
                                              type: "primary",
                                              size: "mini"
                                            },
                                            on: {
                                              click: _vm.openAiRegionRecognition
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.AiRecognition"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.form.prePortEnable
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("Partners.detailAddress")
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { type: "textarea", rows: 3 },
                                  model: {
                                    value: _vm.form.detailAddress,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "detailAddress", $$v)
                                    },
                                    expression: "form.detailAddress"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.lastMileEnable
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_DeliveryAddressType"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        on: {
                                          change: _vm.deliveryAddressTypeChange
                                        },
                                        model: {
                                          value: _vm.form.deliveryAddressType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "deliveryAddressType",
                                              $$v
                                            )
                                          },
                                          expression: "form.deliveryAddressType"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px"
                                            },
                                            attrs: {
                                              label:
                                                _vm.SystemConstants
                                                  .DELIVERY_ADDRESS_TYPE_THIRD_PARTY
                                                  .code
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_ThirdPartyAddress"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-radio",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px"
                                            },
                                            attrs: {
                                              label:
                                                _vm.SystemConstants
                                                  .DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE
                                                  .code
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_AmazonWarehouse"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-radio",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px"
                                            },
                                            attrs: {
                                              label:
                                                _vm.SystemConstants
                                                  .DELIVERY_ADDRESS_TYPE_ECANG
                                                  .code
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_YiCang")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-radio",
                                          {
                                            staticStyle: {
                                              "margin-right": "5px"
                                            },
                                            attrs: {
                                              label:
                                                _vm.SystemConstants
                                                  .DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE
                                                  .code
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_WalmartWarehouse"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm.form.deliveryAddressType ===
                                _vm.SystemConstants
                                  .DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SeaExport.ZIP"),
                                          required: ""
                                        }
                                      },
                                      [
                                        _c("cargo-post-code-select", {
                                          attrs: {
                                            "default-value": _vm.form.postalCode
                                          },
                                          on: { change: _vm.postCodeChange }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.form.deliveryAddressType ===
                                _vm.SystemConstants
                                  .DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SeaExport.Addr")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: _vm.form.address,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "address", $$v)
                                            },
                                            expression: "form.address"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.form.deliveryAddressType ===
                                  _vm.SystemConstants
                                    .DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE
                                    .code ||
                                _vm.form.deliveryAddressType ===
                                  _vm.SystemConstants
                                    .DELIVERY_ADDRESS_TYPE_ECANG.code ||
                                _vm.form.deliveryAddressType ===
                                  _vm.SystemConstants
                                    .DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE
                                    .code
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_WarehouseCode2"
                                          ),
                                          required: ""
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            no: "overseaWarehouseCode",
                                            "select-type":
                                              _vm.TYPE_NAMES
                                                .basic_data_OverseaWarehouse,
                                            filterable: "",
                                            "method-params": { ifFba: true },
                                            clearable: false,
                                            "tag-name": "warehouseCode",
                                            "tag-value": "warehouseCode",
                                            "default-value":
                                              _vm.form.warehouseCode
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.form.warehouseCode = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: !_vm.isEdit,
                          "label-width": "140px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_DirectOrTransshipment"
                              ),
                              required: ""
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "directTransit",
                                "tag-value": "code",
                                filterable: "",
                                clearable: false,
                                "default-value": _vm.form.directTransit,
                                "static-options":
                                  _vm.SystemConstants.DIRECT_TRANSITS
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.directTransit = p.value
                                  _vm.form.transferPortCode = ""
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Airline"),
                              required: ""
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "select-type": _vm.TYPE_NAMES.basic_data_Region,
                                filterable: "",
                                "default-value": _vm.form.commerceCode
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.commerceCode = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_POL"),
                              required: ""
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                filterable: "",
                                "default-value": _vm.form.pol
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.pol = p.value
                                  _vm.fieldChange()
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PortOfDischarge"),
                              required: ""
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                filterable: "",
                                "default-value": _vm.form.pod
                              },
                              on: { parentCallBack: _vm.podChange }
                            })
                          ],
                          1
                        ),
                        _vm.form.directTransit ===
                        _vm.SystemConstants.DIRECT_TRANSIT_TRANSIT.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.TransitPort"),
                                  required: ""
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Seaport,
                                    filterable: "",
                                    "default-value": _vm.form.transferPortCode
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.form.transferPortCode =
                                        p.value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.CargoType"),
                              required: ""
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "cargoType",
                                filterable: "",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_CargoType,
                                "callback-method-type": "value",
                                "default-value": _vm.form.cargoType,
                                "callback-params": { key: "cargoType" }
                              },
                              on: { parentCallBack: _vm.cargoTypeChange }
                            })
                          ],
                          1
                        ),
                        _vm.form.cargoType ===
                        _vm.ImportConstants.CARGOTYPE_DANGEROUS.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.DangerousClass"),
                                  required: ""
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "dangerousGoodsLevel",
                                    "tag-value": "code",
                                    filterable: "",
                                    clearable: false,
                                    "default-value":
                                      _vm.form.dangerousGoodsLevel,
                                    "static-options":
                                      _vm.SystemConstants.DANGEROUS_GOODS_LEVELS
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.dangerousGoodsLevel = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.cargoType ===
                        _vm.ImportConstants.CARGOTYPE_DANGEROUS.code
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "UN NO", required: "" } },
                              [
                                _c("el-input-number", {
                                  staticStyle: { width: "140px" },
                                  attrs: {
                                    no: "unNo",
                                    "controls-position": "right",
                                    precision: 0,
                                    min: 0,
                                    max: 9999
                                  },
                                  model: {
                                    value: _vm.form.unNo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "unNo", $$v)
                                    },
                                    expression: "form.unNo"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.cargoType ===
                        _vm.ImportConstants.CARGOTYPE_OOG.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_Dimensions"),
                                  required: ""
                                }
                              },
                              [
                                _c("cargo-length-width-height", {
                                  attrs: { form: _vm.form }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.cargoType ===
                        _vm.ImportConstants.CARGOTYPE_FROZEN.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.Temperature"),
                                  required: ""
                                }
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: { width: "140px" },
                                  attrs: {
                                    no: "temperature",
                                    "controls-position": "right",
                                    precision: 0
                                  },
                                  model: {
                                    value: _vm.form.temperature,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "temperature", $$v)
                                    },
                                    expression: "form.temperature"
                                  }
                                }),
                                _c("span", [_vm._v("℃")])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.form.cargoType ===
                        _vm.ImportConstants.CARGOTYPE_FROZEN.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "SeaExport.VentilationQuantity"
                                  ),
                                  required: ""
                                }
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: { width: "140px" },
                                  attrs: {
                                    no: "ventilationQuantity",
                                    "controls-position": "right",
                                    precision: 0
                                  },
                                  model: {
                                    value: _vm.form.ventilationQuantity,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "ventilationQuantity",
                                        $$v
                                      )
                                    },
                                    expression: "form.ventilationQuantity"
                                  }
                                }),
                                _c("span", [_vm._v("%")])
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_NameHSCode")
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.form.cargoDescription,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cargoDescription", $$v)
                                },
                                expression: "form.cargoDescription"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_Weight"),
                              required: ""
                            }
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "140px" },
                              attrs: {
                                no: "weight",
                                "controls-position": "right",
                                precision: 2,
                                min: 0
                              },
                              model: {
                                value: _vm.form.weight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "weight", $$v)
                                },
                                expression: "form.weight"
                              }
                            }),
                            _c("span", [_vm._v("KGS")])
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.ShippingCompany")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "carrierId",
                                filterable: "",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Company,
                                "method-params": {
                                  seaCmp: true,
                                  companyLob: "seaExport",
                                  active: true
                                },
                                "default-value": _vm.form.carrierId || 0,
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.carrierId = p.value || 0
                                  _vm.fieldChange()
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea", rows: 3 },
                              model: {
                                value: _vm.form.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "remarks", $$v)
                                },
                                expression: "form.remarks"
                              }
                            })
                          ],
                          1
                        ),
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_CartonQuantity")) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "el-icon-circle-plus",
                            staticStyle: {
                              color: "#42b983",
                              cursor: "pointer",
                              right: "35px",
                              top: "-4px",
                              "font-size": "18px"
                            },
                            on: { click: _vm.addSeaEq }
                          })
                        ]),
                        _vm._l(_vm.form.seaEqList, function(seaEq, index) {
                          return _c("div", { key: index }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "flex-start"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_ContainerSize"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        no: "type",
                                        "tag-value": "code",
                                        filterable: "",
                                        clearable: false,
                                        "default-value": seaEq.type,
                                        "static-options":
                                          _vm.SystemConstants.SEA_EQ_TYPES
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          seaEq.type = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_AmountNumber"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "140px" },
                                      attrs: {
                                        no: "quantity",
                                        clearable: false,
                                        "controls-position": "right",
                                        precision: 0,
                                        min: 1,
                                        max: 99
                                      },
                                      model: {
                                        value: seaEq.quantity,
                                        callback: function($$v) {
                                          _vm.$set(seaEq, "quantity", $$v)
                                        },
                                        expression: "seaEq.quantity"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("i", {
                                  staticClass: "el-icon-remove",
                                  staticStyle: {
                                    color: "#f56c6c",
                                    cursor: "pointer",
                                    right: "35px",
                                    top: "5px",
                                    "font-size": "18px"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteSeaEq(index)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "section", staticStyle: { width: "100%" } },
                [
                  _c(
                    "div",
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MatchQuote")))
                      ]),
                      !_vm.form.uuid ||
                      _vm.form.status ===
                        _vm.SystemConstants.INQUIRY_STATUS_DRAFT.code
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "15px" },
                              attrs: { type: "primary", no: "" },
                              on: { click: _vm.matchPriceClick }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Match")))]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("price-combination-result", {
                    attrs: {
                      type: _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code,
                      "inquiry-form": _vm.form,
                      quotations: _vm.quotations,
                      "trunk-line-enable": _vm.form.trunkLineEnable,
                      "pre-port-enable": _vm.form.prePortEnable,
                      "last-mile-enable": _vm.form.lastMileEnable,
                      "trunk-line-data": _vm.trunkLineData,
                      "pre-port-data": _vm.prePortData,
                      "last-mile-data": _vm.lastMileData,
                      "selected-trunk-line-data": _vm.selectedTrunkLineData,
                      "selected-pre-port-data": _vm.selectedPrePortData,
                      "selected-last-mile-data": _vm.selectedLastMileData,
                      "trunk-line-data-total": _vm.trunkLineDataTotal,
                      "pre-port-data-total": _vm.prePortDataTotal,
                      "last-mile-data-total": _vm.lastMileDataTotal,
                      "data-type": _vm.dataType
                    },
                    on: {
                      radioClickHandler: _vm.radioClickHandler,
                      pagination: _vm.pagination
                    }
                  })
                ],
                1
              ),
              _vm.form && _vm.form.uuid
                ? _c(
                    "div",
                    { staticClass: "section", staticStyle: { width: "100%" } },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.FileHistory")))
                      ]),
                      _vm.isEdit
                        ? _c(
                            "el-form",
                            { staticClass: "section" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "toFileQuery",
                                            type: "primary"
                                          },
                                          on: { click: _vm.toFileQuery }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("FileHistory.Refresh")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: [
                                                "button_FileHistory_fileUpload"
                                              ],
                                              expression:
                                                "['button_FileHistory_fileUpload']"
                                            }
                                          ],
                                          attrs: {
                                            no: "upload",
                                            type: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.file.cloudFile.visible = true
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("FileHistory.Upload"))
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: [
                                                "button_FileHistory_fileDelete",
                                                "role_FileDownloads_ownFileDelete"
                                              ],
                                              expression:
                                                "['button_FileHistory_fileDelete', 'role_FileDownloads_ownFileDelete']"
                                            }
                                          ],
                                          attrs: {
                                            no: "fileRemove",
                                            type: "danger"
                                          },
                                          on: { click: _vm.fileRemove }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("FileHistory.Delete"))
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "fileDownload",
                                            type: "primary"
                                          },
                                          on: { click: _vm.fileDownload }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "FileHistory.BatchDownload"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "fileSendEmail",
                                            type: "primary"
                                          },
                                          on: { click: _vm.fileSendEmail }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("FileHistory.SendEmail")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form",
                        {
                          staticClass: "section",
                          attrs: { disabled: !_vm.isEdit }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c("cargo-ag-grid", {
                                    key: "25070801",
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      "config-module": "25070801",
                                      "grid-params": _vm.file.gridParams,
                                      "grid-options": _vm.file.gridOptions,
                                      "column-defs": _vm.file.columnDefs,
                                      "row-data": _vm.file.rowData
                                    },
                                    on: {
                                      "update:gridParams": function($event) {
                                        return _vm.$set(
                                          _vm.file,
                                          "gridParams",
                                          $event
                                        )
                                      },
                                      "update:grid-params": function($event) {
                                        return _vm.$set(
                                          _vm.file,
                                          "gridParams",
                                          $event
                                        )
                                      },
                                      gridReady: function(params) {
                                        _vm.file.gridApi = params.api
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm.inquiryResponsiblePersonDialog.visible
        ? _c("inquiry-responsible-person-dialog", {
            attrs: {
              visible: _vm.inquiryResponsiblePersonDialog.visible,
              "show-trunk-line":
                _vm.form.trunkLineEnable && !_vm.selectedTrunkLineData,
              "show-pre-port":
                _vm.form.prePortEnable && !_vm.selectedPrePortData,
              "show-last-mile":
                _vm.form.lastMileEnable && !_vm.selectedLastMileData,
              "trunk-line-person-data":
                _vm.inquiryResponsiblePersonDialog.trunkLinePersonData,
              "pre-port-person-data":
                _vm.inquiryResponsiblePersonDialog.prePortPersonData,
              "last-mile-person-data":
                _vm.inquiryResponsiblePersonDialog.lastMilePersonData
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.inquiryResponsiblePersonDialog,
                  "visible",
                  $event
                )
              },
              confirm: _vm.submitStep2
            }
          })
        : _vm._e(),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.file.cloudFile.visible,
          job: _vm.fileCloudFileJob,
          lob: _vm.file.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.file.cloudFile, "visible", $event)
          },
          uploadDone: _vm.toFileQuery
        }
      }),
      _vm.file.isShowingDetailForm
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.file.isShowingDetailForm,
                title: _vm.file.showDetailTitle,
                width: "450px"
              },
              on: {
                close: function() {
                  return (_vm.file.isShowingDetailForm = false)
                }
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "400px", height: "300px" },
                attrs: {
                  "grid-options": _vm.file.gridOptionsFileDetail,
                  "column-defs": _vm.file.columnDefsFileDetail,
                  "row-data": _vm.file.rowDataFileDetail
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.file.gridApiFileDetail = params.api)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.file.sendEmailDialog.visible
        ? _c("send-email-dialog", {
            ref: "file.sendEmailDialog",
            attrs: {
              visible: _vm.file.sendEmailDialog.visible,
              context: null,
              job: _vm.fileCloudFileJob,
              source: "quotationDetailDialog",
              "send-email-data": _vm.file.sendEmailDialog
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.file.sendEmailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("cargo-ai-recognition-dialog", {
        attrs: {
          visible: _vm.aiRecognitionDialog.visible,
          multimodal: _vm.aiRecognitionDialog.multimodal,
          "prompt-key": _vm.aiRecognitionDialog.promptKey,
          "call-back": _vm.aiRecognitionDialog.callBack,
          title: _vm.$t("CargoMsg.CargoMsg_AIAddressRecognition"),
          placeholder: _vm.aiRecognitionDialog.placeholder
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.aiRecognitionDialog, "visible", $event)
          }
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }